import {env, apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/shopify/v1`;

const findShopById = async id => {
  if (env === 'local') {
    return {email: 'shop@local.acerill.com'};
  }
  const {data} = await acerillAuthenticatedAxios.get(`${baseUrl}/shops/${encodeURIComponent(id)}`);
  return data;
};

const findAccessScopes = () => {
  if (env === 'local') {
    return Promise.resolve(['read_customers', 'write_customers']);
  }
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/oauth/access-scopes`)
    .then(response => response.data || []);
};

const findIntegrations = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/integrations`)
    .then(response => response.data);
};

const findCurrentTheme = async () => {
  if (env === 'local') {
    return {onlineStore20: {supported: true}};
  }
  const {data} = await acerillAuthenticatedAxios.get(`${baseUrl}/themes/current`);
  return data;
};

const shopifyV1Client = {
  findShopById,
  findAccessScopes,
  findIntegrations,
  findCurrentTheme,
};

export default shopifyV1Client;
